<template>
    <div>
        <vc-left-menu></vc-left-menu>
        <div :class="{
            'layout-content': true,
            'contents-scroll__wrapper': true,
            'is-active': !getMenuToggle }"
        >
            <PerfectScrollbar style="width: 100%; height: 100%">
                <SchedulesHeader
                    @showRegisterModal="showRegisterModal"
                />

                <section v-if="renderCalendar" class="content__body left__sidebar">
                    <SchedulesSideBar/>
                    <SchedulesCalendar/>
                    <ScheduleRegisterModal/>
                </section>
            </PerfectScrollbar>
        </div>
    </div>
</template>
<script>
import momentDurationFormatSetup from 'moment-duration-format';
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';
import SchedulesHeader from '@/components/cms/common/Schedule/SchedulesHeader';
import SchedulesSideBar from '@/components/cms/common/Schedule/SchedulesSideBar';
import SchedulesCalendar from '@/components/cms/common/Schedule/SchedulesCalendar';
import ScheduleRegisterModal from '@/components/cms/program/Modal/ScheduleRegisterModal';
import { mapGetters, mapMutations } from 'vuex';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    components: {
        SchedulesHeader,
        SchedulesSideBar,
        SchedulesCalendar,
        ScheduleRegisterModal,
    },
    computed: {
        ...mapGetters({
            recordingChannels: 'schedule/recordingChannels',
            registerModalShow: 'schedule_register_modal/registerModalShow',
            program: 'schedule_register_modal/program',
            pickDateTime: 'schedule_register_modal/pickDateTime',
        }),
        registerModalOpen: {
            get() {
                return this.registerModalShow;
            },
            set(val) {
                this.setRegisterModalShow(val);
            },
        },
    },

    data() {
        return {
            renderCalendar: false,
            selectize_channels: null,
            selectizeWaitFiles: null,
            selectizeFiles: null,
            searchedWaitFiles: [],
            searchedFiles: [],
            selectedWaitFile: '',
            selectedFile: '',
            waitFileKeyword: '',
            fileKeyword: '',
            dateDisabled: false,
            submitProcess: false,
        };
    },

    watch: {
        registerModalShow(value) {
            if (value && this.renderCalendar) {
                $('#registerModal').modal({});
            }

            if (!value) {
                $('#registerModal').modal('hide');
                this.clearProgram();
            }
        },
        loadedServiceAccount(newValue) {
            this.initialize();
        },
        selectedChannel(newValue, oldValue) {
            this.renderCalendarEvents();
        },
    },
    mounted() {
        momentDurationFormatSetup(this.$moment);


        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    beforeDestroy() {
        $('#registerModal').hide();
        $('.modal-backdrop').remove();
        this.setRegisterModalShow(false);
        this.clearProgram();
    },
    methods: {
        ...mapMutations({
            setRegisterModalShow: 'schedule_register_modal/setRegisterModalShow',
            clearProgram: 'schedule_register_modal/clearProgram',
        }),
        initialize() {
            this.global_reload_path = 'cms-channels-list';
            this.renderCalendar = true;
        },
        showRegisterModal() {
            // loading 이전에 true 로 바꾸면 모달이 에러나 loading = true 상태 일때만 모달 띄우도록함
            if (this.renderCalendar) {
                this.clearProgram();
                this.registerModalOpen = true;
            }
        },
        showModifyModal() {
            this.registerModalOpen = true;
        },

    },
};
</script>
<style>
.content__header__action .selectize-control {
    min-width: 180px;
}

#date-picker.input-group {
    align-items: center;
}

#date-picker.input-group span {
    padding: 0 8px;
}
</style>
